/**
 * @packageDocumentation
 * @category Component
 */

import 'BomdisoftComponents/inputs/location/styles.css';
import { LocationOnRoundedIcon } from 'BomdisoftComponents/icons/index';
import { parseHighlightedParts } from 'BomdisoftComponents/inputs/combobox/highlight';
import { PlaceType } from 'BomdisoftComponents/types';

export const PlaceOption = ({ place }: { place: PlaceType }) => {
  const matches = place.structured_formatting.main_text_matched_substrings ?? [];
  const parts = parseHighlightedParts(
    place.structured_formatting.main_text,
    matches.map(match => [match.offset, match.offset + match.length] as const),
  );

  return (
    <span className='bomdisoft-location-place'>
      <LocationOnRoundedIcon className='bomdisoft-location-place-icon' size={20} />
      <span className='bomdisoft-location-place-texts'>
        <span className='bomdisoft-location-place-primary'>{parts.map(part => (part.highlight ? <mark key={part.start}>{part.text}</mark> : <span key={part.start}>{part.text}</span>))}</span>
        <span className='bomdisoft-location-place-secondary'>{place.structured_formatting.secondary_text}</span>
      </span>
    </span>
  );
};
